module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_8019.b63f87ab.png";